import { createSelector } from 'reselect';

import { depotsDropdownMapper, depotsPinMapper } from '../../models/depot';

export const getCurrentUser = (state) => state.user;

export const isUserLoggedIn = createSelector(
  getCurrentUser,
  (user) => !!(user && user.uid)
);

export const getUserMetadata = createSelector(
  getCurrentUser,
  ({ metadata = {} }) => metadata
);

export const getUserDepots = createSelector(
  getUserMetadata,
  ({ depotAccess = [] }) => depotAccess
);

export const getDepotsMapObject = createSelector(
  getUserDepots,
  depotsPinMapper
);

export const getDepotsForDropDown = createSelector(
  getUserDepots,
  depotsDropdownMapper
);

export const getCurrentUserId = createSelector(
  getCurrentUser,
  (user) => user.uid
);

export const hasDisasterRecoveryAccess = createSelector(
  getUserMetadata,
  (userMetadata) => userMetadata?.accessDisasterRecovery
);
